import styled from "styled-components";
import { palette } from "../theme/palette";

export const H2 = styled.h2`
  color: ${palette.neutralDarker};
  font-size: 3.6rem;
  font-weight: 700;
`;

export const H3 = styled.h3`
  color: ${palette.neutralDarker};
  font-size: 1.6rem;
  font-weight: 700;
  text-transform: uppercase;
`;

export const Paragraph = styled.p`
  color: ${palette.neutralDarker};
  font-size: 1.8rem;
`;
